import React, {useState} from "react";
import {observer} from "mobx-react";
import {useStores} from "../../Hooks";
import GeneralDialog from "./GeneralDialog";

const SetInteractionNameModal = observer(() => {
    const {modalStore, generalStore} = useStores();

    const [interactionName, setInteractionName] = useState(modalStore.modalData.interactionName || "");

    const trimmedName = interactionName && interactionName.trim();

    const renderBody = () => {
        return (
            <input
                className='site-prep-name-input'
                placeholder={generalStore.translate('addName')}
                value={interactionName}
                onChange={e => setInteractionName(e.target.value)}
            />
        )
    }

    const checkSameName = () => {
        let sameName;
        const interactionMap = modalStore.modalData.interactionMap || new Map();
        interactionMap?.forEach(interaction => {
            if (interaction.ActionName.toLowerCase() === interactionName.toLowerCase()) {
                sameName = true;
            }
        });
        return sameName;
    }

    const onConfirm = async () => {
        if (checkSameName()) {
            return modalStore.showErrorMessage(generalStore.translate('interactionWithSameNameAlreadyExists'));
        }
        modalStore.modalData.interactionName = interactionName;
        modalStore.modalData.onConfirm();
        modalStore.isSetInteractionNameModalOpen = false;
    }

    const onEnter = () => setInteractionName(modalStore.modalData.interactionName || "");

    return (
        <GeneralDialog
            openControl='isSetInteractionNameModalOpen'
            className={'procedure-option-dialog site-prep-options'}
            onEnter={onEnter}
            title={generalStore.translate('renameInteraction')}
            body={renderBody()}
            isConfirmDisabled={!trimmedName}
            confirmText={generalStore.translate('save')}
            onConfirm={onConfirm}
        />
    );
});

export default SetInteractionNameModal;